module.exports = require('./convert')(
  "exportsfunc#&',0123456789;<>?@C[]^`abdghijklmqvwyz{|}~",
  "ثطحخقفسبعدز٫،گو۰۱۲۳۴۵۶۷۸۹ک><؟٬ژ}{×‍‍‍‍`شذیلاهتنمپضرصغظج‍‍|چ‍÷"
)
